import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { SIZES } from '@openx/components-core/lib/theme/sizes.ts';
import { SIDEBAR_TRANSITION_OPTIONS, TOP_BAR_HEIGHT } from '@openx/constants/styles.ts';

export const StyledLayout = styled(Box, {
  shouldForwardProp: prop => prop !== 'isOpen',
})<{ isOpen: boolean }>`
  display: grid;
  grid-template-rows: ${TOP_BAR_HEIGHT}px auto;
  grid-template-columns: ${({ isOpen }) => (isOpen ? SIZES.sidebarWidth : 0)}px auto;
  flex: 1;
  min-height: 0;
  width: 100vw;
  transition: ${({ theme }) => theme.transitions.create('grid-template-columns', SIDEBAR_TRANSITION_OPTIONS)};
  overflow: hidden;
`;
